import MigrateTeamDataModal from "./MigrateTeamDataModal.vue";

Vue.component("team-detail-form", {
    mixins: [require("../../../mixins/address.js")],

    components: {MigrateTeamDataModal},

    props: ["selectedTeam", "franchiseGroups"],

    data () {
        return {
            form: new AppForm({}),
            team: this.selectedTeam,
            showMigrationModal: false,
        };
    },

    computed: {
        companyAddress () {
            return !_.isEmpty(this.team.address.full_address) ? this.team.address.full_address : "No address";
        },

        logoUploadUrl () {
            return "/settings/team/" + this.team.id + "/logo";
        }
    },

    methods: {
        saveTeam () {
            this.form.trading_name = this.team.trading_name;
            this.form.company_name = this.team.company_name;
            this.form.franchise_group = this.team.franchise_group;
            this.form.company_registration_number = this.team.company_registration_number;
            this.form.vat_id = this.team.vat_id;
            this.form.number_of_employees = this.team.number_of_employees;
            this.form.email = this.team.email;
            this.form.phone = this.team.phone;
            this.form.website = this.team.website;

            App.patch("/settings/team/" + this.team.id, this.form)
            .then(() => {
                Bus.$emit("team-updated");
                window.toastr.success("Saved!");
            });
        },

        addressUpdated (address) {
            this.team.address = address;
        },

        toggleMigrationModal() {
            this.showMigrationModal = !this.showMigrationModal;
        },
    },
});
